<div id="orders" class="page-layout carded fullwidth">
    <div class="top-bg primary"></div>
    <div class="center" fusePerfectScrollbar>

        <div class="header primary" fxLayout="column" fxLayoutAlign="center center" fxLayout.gt-xs="row"
            fxLayoutGap="20px" fxLayoutAlign.gt-xs="space-between center">

            <div class="mat-display-1 my-0 my-sm-24 welcome-message">
                <span [@animate]="{value:'*',params:{delay:'100ms',x:'-25px'}}">{{'GENERAL_ZONE_REPORT' |translate}}</span>
            </div>

            <div class="search-wrapper  ml-sm-32">
                <div class="search" fxFlex fxLayout="row" fxLayoutAlign="start center">
                    <mat-icon>search</mat-icon>
                    <input #filter [(ngModel)]="filterText" placeholder="{{'SEARCH' | translate}}">
                </div>
            </div>
            <div>
            </div>

        </div>

        <div class="center">
            <div class="widget-group p-12" fxLayout="row wrap" fxFlex="100" *fuseIfOnDom
                [@animateStagger]="{value:'50'}">

                <fuse-widget [@animate]="{value:'*',params:{y:'100%'}}" class="widget" fxLayout="column" fxFlex="100"
                    fxFlex.gt-xs="50" fxFlex.gt-md="20">

                    <div class="fuse-widget-front h-100-p">
                        <div class="pt-48 px-12 pb-32" fxLayout="column" fxLayoutAlign="center center">
                            <div class="light-blue-fg font-size-52 line-height-52">
                                {{widgetTotalContainer}}
                            </div>
                            <div class="h3 secondary-text font-weight-500">{{'TOTAL_CONTAINER_COUNT' | translate}}
                            </div>
                        </div>
                    </div>

                </fuse-widget> 

                <fuse-widget [@animate]="{value:'*',params:{y:'100%'}}" class="widget" fxLayout="column" fxFlex="100"
                    fxFlex.gt-xs="50" fxFlex.gt-md="20">

                    <div class="fuse-widget-front h-100-p">
                        
                        <div class="pt-48 px-12 pb-32" fxLayout="column" fxLayoutAlign="center center">
                            <div class="red-fg font-size-52 line-height-52">
                                {{widgetTotalOptimize}}
                            </div>
                            <div class="h3 secondary-text font-weight-500">{{'OPTIMIZE_ROUTE_CONTAINER_COUNT'|translate}}
                            </div>
                        </div>
                    </div>
                    
                </fuse-widget>


                <fuse-widget [@animate]="{value:'*',params:{y:'100%'}}" class="widget" fxLayout="column" fxFlex="100"
                    fxFlex.gt-xs="50" fxFlex.gt-md="20">

                    <div class="fuse-widget-front h-100-p">

                        <div class="pt-48 px-12 pb-32" fxLayout="column" fxLayoutAlign="center center">
                            <div class="light-blue-fg font-size-32 line-height-52">
                                {{widgetBaseCost | number : '1.2-2'}}
                            </div>
                            <div class="h3 secondary-text font-weight-500">{{'BASE_COST'|translate}}
                            </div>
                        </div>
      
                    </div>

                </fuse-widget>

                <fuse-widget [@animate]="{value:'*',params:{y:'100%'}}" class="widget" fxLayout="column" fxFlex="100"
                    fxFlex.gt-xs="50" fxFlex.gt-md="20">

                    <div class="fuse-widget-front h-100-p">

                        <div class="pt-48 px-12 pb-32" fxLayout="column" fxLayoutAlign="center center">
                            <div class="orange-fg font-size-32 line-height-52">
                              {{widgetOptimizeCost | number : '1.2-2'}}
                            </div>
                            <div class="h3 secondary-text font-weight-500">{{'OPTIMIZE_COST'|translate}}
                            </div>
                        </div>
               
                    </div>

                </fuse-widget>

                <fuse-widget [@animate]="{value:'*',params:{y:'100%'}}" class="widget" fxLayout="column" fxFlex="100"
                    fxFlex.gt-xs="50" fxFlex.gt-md="20">

                    <div class="fuse-widget-front h-100-p">

                        <div class="pt-48 px-12 pb-32" fxLayout="column" fxLayoutAlign="center center" style="text-align: center;">
                            <div class="purple-fg font-size-32 line-height-52">
                               {{widgetTotalSaving | number : '1.2-2'}}
                            </div>
            
                            <div class="h3 secondary-text font-weight-500">{{'SAVING_TOTAL'|translate}}
                            </div>
                        </div>
                 
                    </div>

                </fuse-widget>

            </div>

        </div>

        <div>
            <div class="content-card p-20">
                <mat-card style="padding: 0 !important;">
                    <div class="p-20 table-select-style" fxLayout="row" fxLayoutAlign="space-between center">
                        <mat-card-title class="custom-card-title" fxFlex="70">
                            <span *ngIf="selectByFilter=='special'"> {{'GENERAL_ZONE_REPORT' | translate}} {{_generalZoneReport.length>0?((_generalZoneReport[0].timeFilterType | timeFilterType) | translate):''}}</span>
                            <span *ngIf="selectByFilter!='special'">{{'GENERAL_ZONE_REPORT' | translate}} ({{((selectByFilter | timeFilterType) | translate)}})</span>
                        </mat-card-title>
                        <div fxLayout="column">
                            <span style="font-size: medium; font-weight: 600;">Tarih Filtresi</span>
                            <div>
                                <span style="font-size: small; font-weight: 300;">{{StartTime | date:"dd.MM.yyyy"}}</span> - 
                                <span style="font-size: small; font-weight: 300;">{{EndTime | date:"dd.MM.yyyy"}}</span>
                            </div>
                        </div>
                        <div fxLayout="row" fxLayoutGap="5px" fxLayoutGap.gt-sm="10px">
                            <button mat-mini-fab [matMenuTriggerFor]="menuUnloadingFilter">
                                <mat-icon>tune</mat-icon>
                            </button>
                            <mat-menu #menuUnloadingFilter="matMenu">
                                <div *ngIf="rootCompanyId==1" mat-menu-item style="height: 75px;" (click)="$event.stopPropagation();">
                                    <mat-form-field class="w-100-p" appearance="outline">
                                        <mat-label>{{'COMPANY'|translate}}</mat-label>
                                        <mat-select [(ngModel)]="companyId">
                                            <mat-option *ngFor="let company of companies" (click)="refresh()"
                                                [value]="company.id">{{company.name}}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <div mat-menu-item style="height: 75px;"  (click)="$event.stopPropagation();">
                                    <mat-form-field class="w-100-p" appearance="outline">
                                        <mat-label>{{'CHOOSE_DATE'|translate}}</mat-label>
                                        <mat-select [(ngModel)]="selectByFilter">
                                            <mat-option (click)="onTimeChangeClick('day')" value="day">
                                                {{'TODAY'|translate}}
                                            </mat-option>
                                            <!-- <mat-option (click)="onTimeChangeClick('week')" value="week">
                                                {{'THIS_WEEK'|translate}}
                                            </mat-option> -->
                                            <mat-option (click)="onTimeChangeClick('month')" value="month">
                                                {{'THIS_MONTH'|translate}}
                                            </mat-option>
                                            <mat-option (click)="onTimeChangeClick('year')" value="year">
                                                {{'THIS_YEAR'|translate}}
                                            </mat-option>
                                            <mat-option [matMenuTriggerFor]="menu" value="special">
                                                {{'OTHER'|translate}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <mat-menu #menu="matMenu">
                                        <div mat-menu-item style="height: 75px;" (click)="$event.stopPropagation();">
                                            <mat-form-field appearance="outline" floatLabel="always">
                                                <mat-label>{{'START_DATE'|translate}}</mat-label>
                                                <input matInput [ngxMatDatetimePicker]="startpicker" name="startpicker"
                                                    placeholder="{{'START_DATE'|translate}}" [(ngModel)]="StartTime" required>
                                                <mat-datepicker-toggle matSuffix [for]="startpicker"></mat-datepicker-toggle>
                                                <ngx-mat-datetime-picker #startpicker>
                                                    <ng-template>
                                                        <span>OK</span>
                                                    </ng-template>
                                                </ngx-mat-datetime-picker>
                                            </mat-form-field>
                                        </div>
                                        <div mat-menu-item style="height: 75px;" (click)="$event.stopPropagation();">
                                            <mat-form-field appearance="outline" floatLabel="always">
                                                <mat-label>{{'END_DATE'|translate}}</mat-label>
                                                <input matInput [ngxMatDatetimePicker]="endRatePicker" name="endRatePicker"
                                                    placeholder="{{'END_DATE'|translate}}" [(ngModel)]="EndTime" required>
                                                <mat-datepicker-toggle matSuffix [for]="endRatePicker"></mat-datepicker-toggle>
                                                <ngx-mat-datetime-picker #endRatePicker>
                                                    <ng-template>
                                                        <span>OK</span>
                                                    </ng-template>
                                                </ngx-mat-datetime-picker>
                                            </mat-form-field>
                                        </div>
                                        <div mat-menu-item
                                            (click)="StartTime && EndTime ?onTimeChangeClick('special',StartTime,EndTime):$event.stopPropagation()">
                                            OK
                                        </div>
                                    </mat-menu>
                                </div>
                            </mat-menu>
                            <!-- <button mat-mini-fab (click)="onReportClick()">
                                <mat-icon>cloud_download</mat-icon>
                            </button> -->
                        </div>

                    </div>
                    <div class="p-20 pt-0" style="overflow: auto;" fusePerfectScrollbar>
                        <mat-table class="orders-table" style="border-radius: 10px 10px 0px 0px; min-width: 700px;" #table matSortActive="beforeDate"
                        matSortDirection="desc"
                            [dataSource]="dataSource" matSort [@animateStagger]="{value:'50'}">

                            <ng-container matColumnDef="name">
                                <mat-header-cell *matHeaderCellDef mat-sort-header>{{'POLIGON_NAME' | translate}}
                                </mat-header-cell>
                                <mat-cell *matCellDef="let generalZone">
                                    <a href="javascript:void(null)" (click)="onTableRowChange(generalZone)">
                                        {{generalZone.name!=null?generalZone.name:"---"}}
                                    </a>
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="totalContainerCount">
                                <mat-header-cell *matHeaderCellDef mat-sort-header>{{'TOTAL_CONTAINER_COUNT' | translate}}
                                </mat-header-cell>
                                <mat-cell *matCellDef="let generalZone">
                                    {{generalZone.totalContainerCount!=null?generalZone.totalContainerCount:"---"}}
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="transactionCriteria">
                                <mat-header-cell *matHeaderCellDef mat-sort-header>{{'TRANSACTION_CRITERIA' | translate}}
                                </mat-header-cell>
                                <mat-cell *matCellDef="let generalZone">
                                    {{generalZone.transactionCriteria!=null?generalZone.transactionCriteria:"---"}}
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="optimizeRouteContainerCount">
                                <mat-header-cell *matHeaderCellDef mat-sort-header>{{'OPTIMIZE_ROUTE_CONTAINER_COUNT' | translate}}
                                </mat-header-cell>
                                <mat-cell *matCellDef="let generalZone">
                                    {{generalZone.optimizeRouteContainerCount!=null?generalZone.optimizeRouteContainerCount:"---"}}
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="transactionContainerCount">
                                <mat-header-cell *matHeaderCellDef mat-sort-header>{{'TRANSACTION_CONTAINER_COUNT' | translate}}
                                </mat-header-cell>
                                <mat-cell *matCellDef="let generalZone">
                                    {{generalZone.transactionContainerCount!=null?generalZone.transactionContainerCount:"---"}}
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="transactionContainerCount2">
                                <mat-header-cell *matHeaderCellDef mat-sort-header>{{'TRANSACTION_CONTAINER_COUNT2' | translate}}
                                </mat-header-cell>
                                <mat-cell *matCellDef="let generalZone">
                                    {{generalZone.transactionContainerCount2!=null?generalZone.transactionContainerCount2:"---"}}
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="baseRouteKm">
                                <mat-header-cell *matHeaderCellDef mat-sort-header>{{'BASE_ROUTE_KM'|translate}}
                                </mat-header-cell>
                                <mat-cell *matCellDef="let generalZone">
                                    {{generalZone.baseRouteKm!=null?((generalZone.baseRouteKm /1000)| number : '1.2-2'):'---'}} 
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="optimizeRouteKm">
                                <mat-header-cell *matHeaderCellDef mat-sort-header>{{'OPTIMIZE_ROUTE_KM'|translate}}
                                </mat-header-cell>
                                <mat-cell *matCellDef="let generalZone">
                                    {{generalZone.optimizeRouteKm!=null?((generalZone.optimizeRouteKm /1000) | number : '1.2-2'):'---'}} 
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="mileageSavings">
                                <mat-header-cell *matHeaderCellDef mat-sort-header>{{'MILEAGE_SAVINGS'|translate}}
                                </mat-header-cell>
                                <mat-cell *matCellDef="let generalZone">
                                    {{generalZone.mileageSavings!=null?(generalZone.mileageSavings | number : '1.2-2'):"---"}}
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="timeSavings">
                                <mat-header-cell *matHeaderCellDef mat-sort-header>{{'TIME_SAVINGS'|translate}}
                                </mat-header-cell>
                                <mat-cell *matCellDef="let generalZone">
                                    {{generalZone.timeSavings!=null?(generalZone.timeSavings | number : '1.2-2'):"---"}}
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="productivity">
                                <mat-header-cell *matHeaderCellDef mat-sort-header>{{'PRODUCTIVITY'|translate}}
                                </mat-header-cell>
                                <mat-cell *matCellDef="let generalZone">
                                    {{generalZone.productivity!=null?(generalZone.productivity | number : '1.2-2'):"---"}}
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="baseCost">
                                <mat-header-cell *matHeaderCellDef mat-sort-header>{{'BASE_COST'|translate}}
                                </mat-header-cell>
                                <mat-cell *matCellDef="let generalZone">
                                    {{generalZone.baseCost!=null?(generalZone.baseCost| number : '1.2-2'):"---"}}
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="optimizeCost">
                                <mat-header-cell *matHeaderCellDef mat-sort-header>{{'OPTIMIZE_COST'|translate}}
                                </mat-header-cell>
                                <mat-cell *matCellDef="let generalZone">
                                    {{generalZone.optimizeCost!=null?(generalZone.optimizeCost | number : '1.2-2'):"---"}}
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="mileageSavingsCost">
                                <mat-header-cell *matHeaderCellDef mat-sort-header>{{'MILEAGE_SAVINGS_COST'|translate}}
                                </mat-header-cell>
                                <mat-cell *matCellDef="let generalZone">
                                    {{generalZone.mileageSavingsCost!=null?(generalZone.mileageSavingsCost | number : '1.2-2'):"---"}}
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="timeSavingsCost">
                                <mat-header-cell *matHeaderCellDef mat-sort-header>{{'TIME_SAVINGS_COST'|translate}}
                                </mat-header-cell>
                                <mat-cell *matCellDef="let generalZone">
                                    {{generalZone.timeSavingsCost!=null?(generalZone.timeSavingsCost | number : '1.2-2'):"---"}}
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="savingTotal">
                                <mat-header-cell *matHeaderCellDef mat-sort-header>{{'SAVING_TOTAL'|translate}}
                                </mat-header-cell>
                                <mat-cell *matCellDef="let generalZone">
                                    {{generalZone.savingTotal!=null?(generalZone.savingTotal | number : '1.2-2'):"---"}}
                                </mat-cell>
                            </ng-container>

                            <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>
                            <mat-row *matRowDef="let generalZone; columns: displayedColumns;" class="order" matRipple>
                            </mat-row>
                        </mat-table>

                        <mat-paginator style="min-width: 700px;" #paginator [length]="paginator.length" [pageSize]="10"
                            [pageSizeOptions]="[10, 50, 100]">
                        </mat-paginator>
                    </div>
                    <mat-progress-bar [fxShow]="tableLoading" style="border-radius: 10px;" mode="indeterminate">
                    </mat-progress-bar>
                </mat-card>

            </div>

            
            <div class="content-card p-20">
                <div class="w-100-p" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="20px">
                    <mat-card fxFlex>
                        <mat-card-title class="custom-card-title" >{{'Tasarruf' | translate}}</mat-card-title>
                        <div id="chartProductivity">
                            <apx-chart
                              [series]="chartOptionsProductivity.series"
                              [chart]="chartOptionsProductivity.chart"
                              [xaxis]="chartOptionsProductivity.xaxis"
                              [stroke]="chartOptionsProductivity.stroke"
                              [theme]="chartOptionsProductivity.theme"
                              [dataLabels]="chartOptionsProductivity.dataLabels"
                              [yaxis]="chartOptionsProductivity.yaxis"
                              [labels]="chartOptionsProductivity.labels"
                              [legend]="chartOptionsProductivity.legend"
                              [title]="chartOptionsProductivity.title"
                            ></apx-chart>
                          </div>
                    </mat-card>
                    
                    <mat-card fxFlex>
                        <mat-card-title class="custom-card-title" >{{'Maliyet Grafiği' | translate}}</mat-card-title>
                        <div id="chartCost">
                            <apx-chart
                              [series]="chartOptionsCost.series"
                              [chart]="chartOptionsCost.chart"
                              [xaxis]="chartOptionsCost.xaxis"
                              [stroke]="chartOptionsCost.stroke"
                              [tooltip]="chartOptionsCost.tooltip"
                              [fill]="chartOptionsCost.fill"
                              [plotOptions]="chartOptionsCost.plotOptions"
                              [theme]="chartOptionsCost.theme"
                              [dataLabels]="chartOptionsCost.dataLabels"
                              [yaxis]="chartOptionsCost.yaxis"
                              [labels]="chartOptionsCost.labels"
                              [legend]="chartOptionsCost.legend"
                              [title]="chartOptionsCost.title"
                            ></apx-chart>
                          </div>
                    </mat-card>
                </div>
            </div>
        </div>

    </div>
</div>